import React, { useState } from "react"
import { Props_ExpandableCardsGrid } from "./ExpandableCardsGrid.props"
import { motion, AnimatePresence } from "framer-motion"
import { Legacy_CompileMarkdown } from "@ClientBase/React/ReactSnippetMDCompiler"

export const ExpandableCardsGrid = (props: Props_ExpandableCardsGrid) => {
    const { heading, repeatable_card } = props;

    // Track a single expanded card instead of multiple
    const [expandedCard, setExpandedCard] = useState<number | null>(null);

    const toggleCard = (index: number) => {
        // If this card is already expanded, collapse it
        // Otherwise expand this card (which automatically collapses any other)
        setExpandedCard(expandedCard === index ? null : index);
    };

    return (
        <section className="attrax-expandable-cards-grid">
            <div className="attrax-expandable-cards-grid__container">
                {heading.text?.value && (
                    <h2 className={`attrax-expandable-cards-grid__heading ${heading.hideHeading?.value === 'hide' ? 'accessible-heading' : ''}`}>{heading.text.value}</h2>
                )}

                <div className="attrax-expandable-cards-grid__card-container">
                    {repeatable_card.map((card, index) => {
                        const isExpanded = expandedCard === index;

                        return (
                            <div
                                className={`attrax-expandable-cards-grid__card ${isExpanded ? 'attrax-expandable-cards-grid__card--is-expanded' : ''}`}
                                key={index}
                            >
                                <div className="attrax-expandable-cards-grid__background-container">
                                    <img
                                        src={card.image?.value}
                                        alt={card.imageAlt?.value || ""}
                                        aria-label={card.imageAriaLabel?.value || ""}
                                        loading="lazy"
                                    />
                                </div>

                                <div className="attrax-expandable-cards-grid__content">
                                    <motion.h3
                                        className="attrax-expandable-cards-grid__card-heading"
                                        initial={{ y: 0 }}
                                        animate={{
                                            y: isExpanded ? 0 : 'auto'
                                        }}
                                    >
                                        {card.heading?.value}
                                    </motion.h3>

                                    <AnimatePresence>
                                        {isExpanded && (
                                            <motion.div
                                                className="attrax-expandable-cards-grid__card-text"
                                                initial={{ opacity: 0, height: 0 }}
                                                animate={{ opacity: 1, height: "100%" }}
                                                exit={{ opacity: 0, height: 0 }}
                                            >
                                                {card.content?.value && Legacy_CompileMarkdown(card.content.value)}
                                            </motion.div>
                                        )}
                                    </AnimatePresence>

                                    <div className="attrax-expandable-cards-grid__button-container">
                                        {isExpanded ? (
                                            <a
                                                href={card.linkUrl?.value}
                                                className="attrax-expandable-cards-grid__card-link"
                                                aria-label={card.linkAriaLabel?.value}
                                            >
                                                {card.linkText?.value}
                                            </a>
                                        ) : (
                                            <button
                                                className="attrax-expandable-cards-grid__expand-button"
                                                onClick={() => toggleCard(index)}
                                                aria-label={card.toggleButtonAriaLabel?.value}
                                            >
                                                {card.toggleButtonText?.value}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};